<h2 mat-dialog-title class="dlg-title">{{ data.title }}</h2>
<mat-dialog-content class="dlg-body">
  @if (data.summary) {
    <p class="summary">{{ data.summary }}</p>
  }
  <section class="dlg-row">
    <div class="lbl">Entrées à annuler</div>
    <div class="targets">
      @for (r of rows; track r.key) {
        <label class="target" [class.off]="!!r.gone">
          <input type="checkbox" [checked]="checked.has(r.key)" [disabled]="!!r.gone" (change)="toggle(r.key, $any($event.target).checked)" />
          <span class="nm">{{ r.name }}<small>{{ r.detail }}</small>@if (r.gone) {<small class="why">{{ r.gone }}</small>}</span>
        </label>
      }
    </div>
    @if (rows.length > 1) {
      <div class="hint">Une annulation est enregistrée par entrée cochée.</div>
    }
  </section>
  <section class="dlg-row">
    <label class="lbl" for="cancel-reason">Motif d'annulation (obligatoire)</label>
    <textarea id="cancel-reason" class="comment" rows="2" [value]="reason" (input)="setReason($any($event.target).value)"
      placeholder="Pourquoi cette décision est annulée"></textarea>
    <div class="hint">La décision annulée reste visible, barrée, avec ce motif.</div>
  </section>
</mat-dialog-content>
<div class="dlg-effect">
  <app-rental-effect [state]="sim" [rangeText]="null" [warnings]="[]" [errors]="errors" [scope]="scope" [focusLineIds]="focusIds" [store]="store"></app-rental-effect>
</div>
<mat-dialog-actions class="dlg-actions">
  <span class="spacer"></span>
  <button mat-stroked-button type="button" class="close" (click)="close()" [disabled]="saving">Fermer</button>
  <button mat-flat-button color="warn" type="button" class="confirm" [disabled]="!canSave || saving" (click)="confirm()">Confirmer l'annulation</button>
</mat-dialog-actions>
